import { useMemo } from 'react';
import type { SupportedLanguage } from '@cubemeet/core/i18n';
import { translateFriends, getTranslatedFriendPresetTags } from '@cubemeet/core/modules/friends/i18n';
import { useI18n } from '../../i18n';

export const useFriendsTranslation = (overrideLanguage?: SupportedLanguage) => {
  const { language } = useI18n();
  const activeLanguage = overrideLanguage || language;

  return useMemo(() => ({
    t: (key: string, params?: Record<string, any>) => translateFriends(activeLanguage, key, params),
    language: activeLanguage,
  }), [activeLanguage]);
};

export const getTranslatedPresetTags = (language: SupportedLanguage) => {
  return getTranslatedFriendPresetTags(language);
};
